<div [class]="componentData?.class" *ngIf="showModal">
  <div [class]="componentData?.modal?.class"
    [id]="componentData?.id"
    aria-modal="true"
    [role]="componentData?.role"
    [attr.aria-labelledby]="componentData?.ariaLabelledby"
    trapFocusDirective
  >
    <div class="closeButtonContainer">
      <button *ngIf="componentData?.header?.closeIcon" class="ods-btn ods-btn-ghost icon-only close"
        title="Close"
        (click)="closeModal.emit()"
        (keyup.enter)="closeModal.emit()"
        [attr.aria-label]="componentData?.close?.ariaLabel"
        autofocusDirective
      ></button>
    </div>
    <ng-content select="[customModalHeader]"></ng-content>
    <div *ngIf="componentData?.header" [class]="componentData?.header?.class">
      <h3 *ngIf="componentData?.header?.title" [attr.aria-label]="componentData?.header?.ariaLabel" [id]="componentData?.header?.title?.id">{{ componentData?.header?.title?.text }}</h3>
      <button *ngIf="componentData?.header?.inlineBtn" [id]="componentData?.header?.inlineBtn?.id"
        class="crossIcon ods-btn ods-btn-ghost icon-only close on-dark-background"
        title="Close"
        (click)="onCloseModal()"
        (keyup.enter)="onCloseModal()"
        [attr.aria-label]="componentData?.close?.ariaLabel"
        autofocusDirective
      >
      </button>
      <span *ngIf="componentData?.header?.subTitle" [attr.aria-label]="componentData?.header?.subTitle?.ariaLabel" [class]="componentData?.header?.subTitle?.class">{{ componentData?.header?.subTitle?.text }}</span>
    </div>
    <ng-content select="[customModalBody]"></ng-content>
    <div *ngIf="componentData?.body" [class]="componentData?.body?.class">
      <section [class]="componentData?.body?.subClass" *ngFor="let data of componentData?.body?.text">
        <p [attr.aria-label]="componentData?.body?.ariaLabel" [innerHtml]="data"></p>
      </section>
    </div>
    <ng-content select="[customModalFooter]"></ng-content>
    <div *ngIf="componentData?.footer" [class]="componentData?.footer?.class">
      <section class="btns" *ngFor="let data of componentData?.footer?.buttons" class="tootltip-wrapper {{ data.wrapperClass }}" tooltipDirective [data]="data?.text">
        <button [class]="data?.class" [attr.aria-label]="data.ariaLabel" [disabled]="data.disabled && data.disabled() || undefined" (click)="onButtonClick(data?.id, data)">
          {{ data?.text }}
        </button>
      </section>
    </div>
  </div>
</div>
